<template>
  <tab-layout :actionBar="true">
    <member-admin-add-details :memberDetails="memberDetails" :edit="edit" slot="tabContent" class="tab-pane row mx-0 show active" />
  </tab-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import tabLayout from '@/components/TabLayout'
import memberAdminAddDetails from './AdminAddDetails'

export default {
  name: 'MemberAdminAdd',
  props: ['memberDetails', 'edit'],
  components: {
    'tab-layout': tabLayout,
    'member-admin-add-details': memberAdminAddDetails
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Admin/Add/AdminAdd.vue